export default {
 lang_name: '繁體中文',
 tab_mine: '挖礦', tab_upgrade: '強化', tab_prestige: '轉生', tab_achievement: '成就', tab_settings: '設定',
 hud_cps: '/秒', hud_tap: '/點擊', hud_combo: 'x',
 action_daily_bonus: '每日獎勵', action_turbo: '加速', action_ad_boost: '廣告加成',
 gen_gen1: '手機挖礦', gen_gen2: '筆電挖礦', gen_gen3: '桌機挖礦', gen_gen4: 'GPU礦機', gen_gen5: 'ASIC礦機', gen_gen6: '礦場', gen_gen7: '數據中心', gen_gen8: '量子電腦', gen_gen9: 'AI挖礦機器人', gen_gen10: '衛星礦機', gen_gen11: '月球挖礦基地', gen_gen12: '銀河挖礦網路',
 gen_gen1_theme: '口袋副業', gen_gen2_theme: '咖啡廳礦工', gen_gen3_theme: '網咖打工', gen_gen4_theme: '顯卡搶購潮', gen_gen5_theme: '專業設備', gen_gen6_theme: '貨櫃農場', gen_gen7_theme: '企業級基建', gen_gen8_theme: '未來科技', gen_gen9_theme: '自動挖礦', gen_gen10_theme: '太空擴張', gen_gen11_theme: '月球征服', gen_gen12_theme: '宇宙統治',
 locked: '未解鎖',
 upg_cat_generator: '生產機升級', upg_cat_global: '全域升級', upg_cat_research: '研究', upg_cat_darkpool: '暗池',
 upg_empty: '尚未解鎖升級', upg_empty_hint: '購買生產機以解鎖升級',
 upg_up_gen1_t1: '手機效率化', upg_up_gen1_t1_desc: '手機挖礦x2', upg_up_gen1_t2: '手機特化', upg_up_gen1_t2_desc: '手機挖礦x2', upg_up_gen1_t3: '手機大師', upg_up_gen1_t3_desc: '手機挖礦x2',
 upg_up_gen2_t1: '筆電效率化', upg_up_gen2_t1_desc: '筆電挖礦x2', upg_up_gen2_t2: '筆電特化', upg_up_gen2_t2_desc: '筆電挖礦x2', upg_up_gen2_t3: '筆電大師', upg_up_gen2_t3_desc: '筆電挖礦x2',
 upg_up_gen3_t1: '桌機效率化', upg_up_gen3_t1_desc: '桌機挖礦x2', upg_up_gen3_t2: '桌機特化', upg_up_gen3_t2_desc: '桌機挖礦x2', upg_up_gen3_t3: '桌機大師', upg_up_gen3_t3_desc: '桌機挖礦x2',
 upg_up_gen4_t1: 'GPU效率化', upg_up_gen4_t1_desc: 'GPU挖礦x2', upg_up_gen4_t2: 'GPU特化', upg_up_gen4_t2_desc: 'GPU挖礦x2', upg_up_gen4_t3: 'GPU大師', upg_up_gen4_t3_desc: 'GPU挖礦x2',
 upg_up_gen5_t1: 'ASIC效率化', upg_up_gen5_t1_desc: 'ASIC挖礦x2', upg_up_gen5_t2: 'ASIC特化', upg_up_gen5_t2_desc: 'ASIC挖礦x2', upg_up_gen5_t3: 'ASIC大師', upg_up_gen5_t3_desc: 'ASIC挖礦x2',
 upg_up_gen6_t1: '礦場效率化', upg_up_gen6_t1_desc: '礦場挖礦x2', upg_up_gen6_t2: '礦場特化', upg_up_gen6_t2_desc: '礦場挖礦x2', upg_up_gen6_t3: '礦場大師', upg_up_gen6_t3_desc: '礦場挖礦x2',
 upg_up_gen7_t1: '數據中心效率化', upg_up_gen7_t1_desc: '數據中心挖礦x2', upg_up_gen7_t2: '數據中心特化', upg_up_gen7_t2_desc: '數據中心挖礦x2', upg_up_gen7_t3: '數據中心大師', upg_up_gen7_t3_desc: '數據中心挖礦x2',
 upg_up_gen8_t1: '量子效率化', upg_up_gen8_t1_desc: '量子挖礦x2', upg_up_gen8_t2: '量子特化', upg_up_gen8_t2_desc: '量子挖礦x2', upg_up_gen8_t3: '量子大師', upg_up_gen8_t3_desc: '量子挖礦x2',
 upg_up_gen9_t1: 'AI機器人效率化', upg_up_gen9_t1_desc: 'AI機器人挖礦x2', upg_up_gen9_t2: 'AI機器人特化', upg_up_gen9_t2_desc: 'AI機器人挖礦x2', upg_up_gen9_t3: 'AI機器人大師', upg_up_gen9_t3_desc: 'AI機器人挖礦x2',
 upg_up_gen10_t1: '衛星效率化', upg_up_gen10_t1_desc: '衛星挖礦x2', upg_up_gen10_t2: '衛星特化', upg_up_gen10_t2_desc: '衛星挖礦x2', upg_up_gen10_t3: '衛星大師', upg_up_gen10_t3_desc: '衛星挖礦x2',
 upg_up_gen11_t1: '月球效率化', upg_up_gen11_t1_desc: '月球挖礦x2', upg_up_gen11_t2: '月球特化', upg_up_gen11_t2_desc: '月球挖礦x2', upg_up_gen11_t3: '月球大師', upg_up_gen11_t3_desc: '月球挖礦x2',
 upg_up_gen12_t1: '銀河效率化', upg_up_gen12_t1_desc: '銀河挖礦x2', upg_up_gen12_t2: '銀河特化', upg_up_gen12_t2_desc: '銀河挖礦x2', upg_up_gen12_t3: '銀河大師', upg_up_gen12_t3_desc: '銀河挖礦x2',
 upg_up_global_click1: '強化手指', upg_up_global_click1_desc: '點擊力x2', upg_up_global_click2: '機械手指', upg_up_global_click2_desc: '點擊力x3',
 upg_up_global_cps1: '超頻', upg_up_global_cps1_desc: '全部自動收入 +50%', upg_up_global_cps2: '極限超頻', upg_up_global_cps2_desc: '全部自動收入 x2',
 upg_up_global_golden1: '幸運天線', upg_up_global_golden1_desc: '黃金持續+50%', upg_up_global_golden2: '黃金磁鐵', upg_up_global_golden2_desc: '黃金頻率x2',
 upg_up_global_offline: '自動挖礦優化', upg_up_global_offline_desc: '離線率50%->75%', upg_up_global_combo: '連擊延長', upg_up_global_combo_desc: '連擊持續3秒->5秒',
 upg_up_res_synergy: '協同演算法', upg_up_res_synergy_desc: '每種生產機自動收入+10%', upg_up_res_quantum: '量子加速', upg_up_res_quantum_desc: '全部自動收入 x3', upg_up_res_ai_click: 'AI點擊輔助', upg_up_res_ai_click_desc: '點擊力x5', upg_up_res_golden_master: '黃金大師', upg_up_res_golden_master_desc: '黃金效果x2+持續x2', upg_up_res_prestige_boost: '轉生催化劑', upg_up_res_prestige_boost_desc: '轉生區塊鏈+50%', upg_up_res_combo_max: '連擊終結者', upg_up_res_combo_max_desc: '最大連擊倍率2x->3x',
 upg_up_dp_scam_promo: '詐騙幣宣傳', upg_up_dp_scam_promo_desc: '暗池獎勵x2',
 upg_up_dp_insider_net: '內線網路', upg_up_dp_insider_net_desc: '內線準確率80%->95%',
 upg_up_dp_chip_laundry: '豪賭客', upg_up_dp_chip_laundry_desc: '最大下注比例25%→50%',
 upg_up_dp_whale_ctrl: '鯨魚操控', upg_up_dp_whale_ctrl_desc: '8x,12x倍率機率大幅增加',
 prestige_blockchain_title: '區塊鏈轉生', prestige_blockchain_held: '持有', prestige_blockchain_bonus: '加成', prestige_count: '轉生次數', prestige_count_unit: '次', prestige_gain: '轉生時', prestige_blockchain: '區塊鏈', prestige_execute: '轉生', prestige_need: '需要總生產1M以上', prestige_current: '目前',
 prestige_buff_title: '區塊鏈增益', prestige_buff_level: 'Lv.',
 buff_click: '點擊力增幅', buff_click_desc: '每級點擊+5%', buff_cps: '自動收入增幅', buff_cps_desc: '每級自動收入+5%', buff_golden: '黃金機率', buff_golden_desc: '每級黃金+2%', buff_offline: '離線效率', buff_offline_desc: '每級離線+5%',
 buff_ex_seed: '種子資金補助', buff_ex_seed_desc: '轉生時給予少量起始種子資金', buff_ex_rescue_cd: '攤平專線', buff_ex_rescue_cd_desc: '攤平緊急資金冷卻時間略微縮短', buff_ex_leak: '內部消息來源', buff_ex_leak_desc: '稍早收到小道消息',
 prestige2_title: '元宇宙轉生', prestige2_coins: '元宇宙幣', prestige2_count: '二次轉生', prestige2_gain: '二次轉生時', prestige2_execute: '二次轉生', prestige2_need: '需要100+區塊鏈', prestige2_locked_title: '元宇宙轉生', prestige2_locked_desc: '需要轉生5次+區塊鏈50', prestige2_locked_current: '目前',
 prestige2_meta_title: '元宇宙升級',
 meta_auto_tap: '自動點擊機器人', meta_auto_tap_desc: '每秒自動點擊', meta_golden_boost: '黃金加成', meta_golden_boost_desc: '黃金頻率x2', meta_offline_time: '離線延長', meta_offline_time_desc: '離線8h->16h', meta_milestone_boost: '里程碑加成', meta_milestone_boost_desc: '里程碑x2->x3', meta_prestige_amplify: '轉生增幅', meta_prestige_amplify_desc: '區塊鏈效果1%->2%',
 prestige_confirm_title: '轉生確認', prestige_confirm_gain: '獲得', prestige_confirm_after: '轉生後', prestige_confirm_warn_1: '金幣、生產機重置', prestige_confirm_keep_1: '區塊鏈、成就保留',
 prestige2_confirm_title: '二次轉生', prestige2_confirm_warn: '金幣、生產機、區塊鏈全部重置', prestige2_confirm_keep: '元宇宙幣、成就保留',
 ach_title: '成就', ach_cat_production: '生產', ach_cat_generator: '生產機', ach_cat_prestige: '轉生', ach_cat_click: '點擊', ach_cat_golden: '黃金', ach_cat_special: '特殊',
 ach_ach_prod_1: '第一枚幣', ach_ach_prod_1_desc: '生產1枚幣', ach_ach_prod_2: '百萬富翁', ach_ach_prod_2_desc: '生產1M幣', ach_ach_prod_3: '億萬富翁', ach_ach_prod_3_desc: '生產1B幣', ach_ach_prod_4: '兆富翁', ach_ach_prod_4_desc: '生產1T幣', ach_ach_prod_5: '京富翁', ach_ach_prod_5_desc: '生產1Qa幣', ach_ach_prod_6: '垓富翁', ach_ach_prod_6_desc: '生產1Qi幣', ach_ach_prod_7: '秭富翁', ach_ach_prod_7_desc: '生產1Sx幣', ach_ach_prod_8: '穰富翁', ach_ach_prod_8_desc: '生產1Sp幣', ach_ach_prod_9: '溝富翁', ach_ach_prod_9_desc: '生產1Oc幣', ach_ach_prod_10: '澗富翁', ach_ach_prod_10_desc: '生產1No幣', ach_ach_prod_11: '正富翁', ach_ach_prod_11_desc: '生產1Dc幣', ach_ach_prod_12: '載富翁', ach_ach_prod_12_desc: '生產1UDc幣',
 ach_ach_gen_1: '手機大師', ach_ach_gen_1_desc: '手機100台', ach_ach_gen_2: '筆電大師', ach_ach_gen_2_desc: '筆電100台', ach_ach_gen_3: '桌機大師', ach_ach_gen_3_desc: '桌機100台', ach_ach_gen_4: 'GPU大師', ach_ach_gen_4_desc: 'GPU100台', ach_ach_gen_5: 'ASIC大師', ach_ach_gen_5_desc: 'ASIC100台', ach_ach_gen_6: '礦場大師', ach_ach_gen_6_desc: '礦場100台', ach_ach_gen_7: '數據中心大師', ach_ach_gen_7_desc: '數據中心100台', ach_ach_gen_8: '量子大師', ach_ach_gen_8_desc: '量子電腦100台', ach_ach_gen_9: 'AI大師', ach_ach_gen_9_desc: 'AI機器人100台', ach_ach_gen_10: '衛星大師', ach_ach_gen_10_desc: '衛星100台', ach_ach_gen_11: '月球大師', ach_ach_gen_11_desc: '月球基地100台', ach_ach_gen_12: '銀河大師', ach_ach_gen_12_desc: '銀河網路100台',
 ach_ach_pres_1: '初次轉生', ach_ach_pres_1_desc: '轉生1次', ach_ach_pres_2: '轉生大師', ach_ach_pres_2_desc: '轉生10次', ach_ach_pres_3: '轉生傳說', ach_ach_pres_3_desc: '轉生50次', ach_ach_pres_4: '區塊鏈收藏家', ach_ach_pres_4_desc: '區塊鏈100個', ach_ach_pres_5: '元宇宙入場', ach_ach_pres_5_desc: '二次轉生1次', ach_ach_pres_6: '元宇宙大亨', ach_ach_pres_6_desc: '二次轉生5次', ach_ach_pres_7: '區塊鏈之王', ach_ach_pres_7_desc: '區塊鏈500個', ach_ach_pres_8: '轉生之神', ach_ach_pres_8_desc: '轉生100次',
 ach_ach_click_1: '點擊新手', ach_ach_click_1_desc: '點擊100次', ach_ach_click_2: '點擊狂人', ach_ach_click_2_desc: '點擊1,000次', ach_ach_click_3: '點擊成癮', ach_ach_click_3_desc: '點擊10,000次', ach_ach_click_4: '點擊之神', ach_ach_click_4_desc: '點擊100,000次', ach_ach_click_5: '手腕終結者', ach_ach_click_5_desc: '連擊50', ach_ach_click_6: '10TPS達人', ach_ach_click_6_desc: '連擊100',
 ach_ach_golden_1: '黃金獵人', ach_ach_golden_1_desc: '黃金點擊10次', ach_ach_golden_2: '黃金大師', ach_ach_golden_2_desc: '黃金點擊50次', ach_ach_golden_3: '黃金傳說', ach_ach_golden_3_desc: '黃金點擊200次', ach_ach_golden_4: '幸運之手', ach_ach_golden_4_desc: '幸運黃金5次',
 ach_ach_spec_1: '廣告支持者', ach_ach_spec_1_desc: '觀看廣告10次', ach_ach_spec_2: '廣告VIP', ach_ach_spec_2_desc: '觀看廣告100次', ach_ach_spec_3: '離線富翁', ach_ach_spec_3_desc: '領取離線10次', ach_ach_spec_4: '出勤王', ach_ach_spec_4_desc: '連續7天', ach_ach_spec_5: '完美主義者', ach_ach_spec_5_desc: '每種生產機100台', ach_ach_spec_6: '點擊大師', ach_ach_spec_6_desc: '金幣點擊1,000次', ach_ach_spec_7: '速度狂', ach_ach_spec_7_desc: '1小時1B不轉生', ach_ach_spec_8: '完成者', ach_ach_spec_8_desc: '達成所有成就',
 ach_reward_cps: '+{v}% 自動收入', ach_reward_click: '+{v}% 點擊', ach_reward_prestige: '轉生',
 golden_golden_coin: '黃金幣', golden_golden_coin_desc: '即時自動收入 x777', golden_lucky_golden: '幸運黃金', golden_lucky_golden_desc: '15秒自動收入 x7', golden_click_frenzy: '點擊狂熱', golden_click_frenzy_desc: '30秒點擊x10', golden_production_boost: '生產加成', golden_production_boost_desc: '30秒全部生產x5', golden_mega_jackpot: '超級頭獎', golden_mega_jackpot_desc: '目前金幣x10',
 settings_title: '設定', settings_sound: '音效', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_language: '語言', settings_stats_title: '統計', settings_total_earned: '總生產量', settings_total_taps: '總點擊', settings_max_combo: '最高連擊', settings_golden_clicks: '黃金點擊', settings_prestige_count: '轉生', settings_prestige2_count: '二次轉生', settings_play_time: '遊戲時間', settings_data_title: '資料', settings_save: '手動儲存', settings_saved: '已儲存!', settings_reset: '重置資料', settings_reset_confirm: '確定要重置所有資料嗎?',
 offline_title: '離線獎勵', offline_duration: '挖礦了', offline_capped: '(最大)', offline_claim: '領取', offline_ad_double: '廣告x2',
 confirm: '確認', cancel: '取消',
 ad_cps_boost: '自動收入加成30秒', ad_offline_double: '離線x2', ad_prestige_bonus: '轉生+50%', ad_timeskip: '2小時跳過', ad_free_docs: '免費文件', ad_golden_double: '黃金x2', ad_start_boost: '開始加成60秒', ad_income_x5: '收入x10', ad_tap_x10: '點擊x10',
 ad_income_x5_desc: '15秒收入10倍',
 ad_timeskip_desc: '即時2小時產量',
 ad_tap_x10_desc: '15秒點擊10倍',
 ad_popup_income_title: '收入x10加速',
 ad_popup_income_desc: '觀看廣告，15秒內所有收入提升10倍！',
 ad_popup_timeskip_title: '2小時時間跳躍',
 ad_popup_timeskip_desc: '觀看廣告，立即獲得2小時的金幣產量！',
 ad_popup_tap_title: '點擊力量x10',
 ad_popup_tap_desc: '觀看廣告，15秒內點擊力量提升10倍！',
 ad_popup_watch: '觀看廣告',
 ad_popup_cancel: '關閉',
 ach_toast: '達成!',
 action_daily: '每日獎勵',
 gen_locked: '鎖定',
 prestige_blockchain_owned: '持有區塊鏈',
 prestige_reward_prefix: '轉生時 ',
 prestige_blockchain_unit: '區塊鏈',
 prestige_btn: '轉生',
 prestige_need_1m: '需要總產量4M以上',
 prestige_confirm_warn: '代幣、生產機重置',
 prestige_confirm_keep: '區塊鏈、成就保留',
 btn_cancel: '取消',
 prestige2_meta_coins: '元宇宙代幣',
 prestige2_reward_prefix: '二次轉生時 ',
 prestige2_meta_unit: '元宇宙代幣',
 prestige2_btn: '二次轉生',
 prestige2_need_100: '需要區塊鏈100個以上',
 prestige2_confirm_gain: '獲得',
 prestige2_upgrades_title: '元宇宙升級',
 ach_reward_tap: '點擊',
 ach_reward_golden: '黃金',
 ach_unlocked: '達成!',
 settings_stats: '統計',
 stats_total_earned: '總產量',
 stats_total_clicks: '總點擊',
 stats_max_combo: '最高連擊',
 stats_golden_clicks: '黃金點擊',
 stats_prestige_count: '轉生',
 stats_prestige2_count: '二次轉生',
 stats_play_time: '遊玩時間',
 settings_data: '資料',
 toast_saved: '已儲存!',
 settings_reset_title: '重置資料',
 // Market sentiment
 market_price: '行情',
 manip_sns_hype: 'SNS炒作',
 manip_sns_hype_desc: '推動價格上漲(30%反效果)',
 manip_influencer: '網紅帶貨',
 manip_influencer_desc: '穩定推動價格上漲',
 manip_pump_dump: '拉高出貨',
 manip_pump_dump_desc: '暴漲後暴跌',

 // Dark Pool
 tab_darkpool: '暗池',
 dp_title: 'Dark Pool',
 dp_total_bets: '總下注',
 dp_banner_soon: '暗池開始',
 dp_banner_live: '暗池進行中！',
 dp_skip_cooldown: '看廣告立即開始',
 dp_wins: '勝利',
 dp_profit: '淨利潤',
 dp_next_round: '下一輪倒數',
 dp_bet_hint: '用你的幣來下注吧',
 dp_bet_coins: '幣下注',
 dp_available: '持有',
 dp_win_preview: '預估獎勵',
 dp_real_coins: '幣',
 dp_tutorial_title: 'Dark Pool 指南',
 dp_tutorial_1: 'Dark Pool 是用虛擬籌碼參與硬幣拍賣的迷你遊戲。',
 dp_tutorial_2: '每回合免費獲得100籌碼，不使用真實硬幣！',
 dp_tutorial_3: '中獎時籌碼會轉換為真實硬幣。（基於自動收入）',
 dp_tutorial_4: '觀看廣告可獲得內部消息。（80%準確率）',
 dp_betting: '下注進行中',
 dp_your_bet: '我的下注',
 dp_get_insider: '內幕消息',
 dp_place_bet: '下注',
 dp_bet_placed: '下注完成',
 dp_waiting_result: '等待結果中...',
 dp_revealing: '公佈結果中',
 dp_result: '結果',
 dp_you_won: '中獎!',
 dp_you_lost: '落選...',
 dp_claim: '領取',
 dp_no_bet: '本輪跳過',
 dp_was_winner: '中獎!',
 dp_insider_title: '內幕消息',
 dp_insider_hint: '上漲機率80%! 預估',
 dp_insider_warn: '* 資訊可能不是100%準確',
 dp_insider_received: '已獲取內幕消息!',

 // Golden event modal
 golden_event: '黃金事件',
 golden_claim_normal: '領取',
 golden_claim_ad: '廣告x2',

 // Prestige ad
 prestige_ad_bonus: '廣告+100%',

 // Ad boost
 golden_ad_income_x5: 'x10 加成',

 // Exchange
 exchange_title: 'Coin Exchange', exchange_buy: 'Buy', exchange_sell: 'Sell', exchange_holdings: 'Holdings', exchange_avg_price: 'Avg', exchange_profit: 'P&L', exchange_unlock: 'Unlock', exchange_locked: 'Locked', exchange_news: 'News', exchange_24h: 'Change',
 news_celeb_tweet: 'Famous influencer mentions PIKA!', news_hack: 'Major exchange hacked!', news_nova_update: 'NOVA network major update!', news_whale_buy: 'Whale buys in bulk!', news_regulation: '️ Regulatory crackdown!', news_frog_burn: 'Massive FROG burn event!', news_bolt_partner: 'BOLT signs major partnership!', news_star_listing: 'STAR listed on major exchange!', news_bull_market: 'Bull market signal!', news_bear_market: 'Bear market warning!',

 // Onboarding
 onboarding_tap: '點擊挖掘硬幣！',
 onboarding_buy: '用硬幣購買生產器！',
 ob_step0: '點擊硬幣來挖礦！',
 ob_step1: '用賺來的幣去交易所投資吧',
 ob_step2: '試著買這個幣',
 ob_step3: '在漲了！現在賣就賺翻！',
 ob_step4: '把挖到的幣在交易所翻了好幾倍！這就是遊戲的核心',
 ob_skip: '跳過',

 // === 交易所 (v2.0) ===
 tab_exchange: '交易所',
 coin_stonecoin: '石頭幣',
 ex_my_holdings: '我的投資',
 ex_invested: '投資本金',
 ex_valuation: '評估金額',
 ex_eval_pnl: '評估損益',
 ex_all_coins: '所有幣種',
 coin_nebula: '星雲幣',
 coin_chickencoin: '炸雞幣',
 coin_moonfrog: '月亮蛙',
 coin_pumpking: '泵浦王',
 coin_lattice: '晶格幣',
 coin_moonshot: '登月幣',
 coin_pizzaswap: '披薩交換',
 coin_catchain: '貓鏈',
 coin_rocksolid: '磐石幣',
 coin_yolocoin: '搏一把幣',
 coin_ramenfi: '拉麵金融',
 coin_ghostnet: '幽靈網',
 coin_crabdao: '螃蟹DAO',
 coin_tacotoken: '塔可幣',
 coin_sockswap: '襪子交換',
 coin_ufomoney: '幽浮幣',
 coin_doomfloor: '末日地板',
 coin_lambodream: '超跑夢',
 coin_diamondpaw: '鑽石爪',
 coin_rugbeater: '跑路剋星',
 coin_sushirocket: '壽司火箭',
 coin_nyanfi: '喵金融',
 coin_gigachad: '超級猛男幣',
 coin_kimchibase: '泡菜鏈',
 coin_popcat: '砰砰貓',
 coin_baguettefi: '法棍金融',
 coin_vaporwave: '蒸汽波',
 coin_brrrcoin: '印鈔幣',
 coin_panicsell: '恐慌賣幣',
 coin_wenmoon: '何時登月',
 ex_delisted_badge: '已下架',
 ex_revived_badge: '重生',
 cnews_list_new: '{coin} 登陸交易所 - 新上架話題延燒',
 cnews_list_delist: '{coin} 因交易量枯竭下架 - 持倉自動清算',
 cnews_list_revive: '{coin} 起死回生 - 改頭換面重新上架',
 ex_title: '交易所',
 ex_total_assets: '總資產',
 ex_cash: '持有金幣',
 ex_total_pnl: '總損益率',
 ex_holding_badge: '持有',
 ex_back: '返回',
 ex_no_holding: '尚未持有此幣種',
 ex_amount: '數量',
 ex_avg_price: '平均成本',
 ex_value: '市值',
 ex_pnl: '損益率',
 ex_buy: '買入',
 ex_sell: '賣出',
 ex_max: '最大',
 ex_spend: '買入金額',
 ex_sell_amount: '賣出數量',
 ex_buy_success: '買入成交！',
 ex_sell_success: '賣出成交！',
 ex_insufficient_funds: '金幣不足',
 ex_insufficient_holding: '持有數量不足',

 // === Info economy (Sprint 2a) ===
 news_feed_title: '快訊',
 news_section_title: '市場消息',
 news_ticker_empty: '目前沒有新消息',
 news_now: '剛剛',
 news_leak_tag: '小道消息',
 leak_verdict_true: '命中',
 leak_verdict_fake: '落空',
 factcheck_btn: '事實查核',
 factcheck_sub: '看廣告確認真偽',
 factcheck_true: '真實情報',
 factcheck_fake: '假消息',
 leak_confirmed_target: '已確認目標',
 leak_up_1: '大戶資金疑似流入{coin}？',
 leak_up_2: '傳聞{coin}即將有重大利多',
 leak_up_3: '據說內部人士正悄悄吃貨{coin}',
 leak_down_1: '{coin}大量賣壓正在醞釀？',
 leak_down_2: '傳出{coin}將有壞消息...',
 leak_down_3: '發現大戶正在撤出{coin}',
 cnews_listing: '{coin}確定上架大型交易所',
 cnews_celebrity: '知名藝人透露持有{coin}',
 cnews_partnership: '{coin}基金會與大企業簽署合作',
 cnews_burn: '{coin}宣布大規模銷毀代幣',
 cnews_upgrade: '{coin}網路升級成功',
 cnews_etf: '報導稱{coin} ETF即將獲批',
 cnews_payment: '大型購物網站導入{coin}支付',
 cnews_viral: '{coin}迷因在社群爆紅',
 cnews_airdrop: '{coin}宣布向持有者空投',
 cnews_buyback: '{coin}基金會啟動回購計畫',
 cnews_influencer_news: '百萬訂閱YouTuber深度分析{coin}',
 cnews_patent: '{coin}開發商申請核心技術專利',
 cnews_devs_missing: '傳{coin}開發團隊失聯',
 cnews_hack: '發現{coin}錢包疑似遭駭',
 cnews_regulation: '金融主管機關開始審查{coin}',
 cnews_delisting: '傳部分交易所考慮下架{coin}',
 cnews_whale_sell: '{coin}大戶錢包大量拋售',
 cnews_lawsuit: '{coin}基金會遭集體訴訟',
 cnews_bug: '{coin}智能合約發現漏洞',
 cnews_founder_sell: '{coin}創辦人疑似出售持幣',
 cnews_fud: '知名分析師痛批{coin}已完蛋',
 cnews_outage: '{coin}網路短暫中斷',
 cnews_stone_difficulty: '{coin}挖礦難度創新高，礦工出走',
 cnews_stone_museum: '國立博物館將展出{coin}創世區塊',
 cnews_nebula_launch: '{coin}衛星節點發射成功',
 cnews_nebula_debris: '{coin}節點衛星險撞太空垃圾',
 cnews_chicken_payment: '連鎖炸雞店導入{coin}支付',
 cnews_chicken_flu: '禽流感擴散，{coin}社群陷入恐慌',
 cnews_frog_moon: '{coin}社群「衝上月球」迷因爆發',
 cnews_frog_pond: '{coin}巨鯨稱要回池塘，全數拋售',
 cnews_pump_festival: '{coin}南瓜節登場，新錢包暴增',
 cnews_pump_probe: '{coin}涉嫌操縱價格遭調查',
 cd_manip_title: '帶風向',
 cd_manip_active: '帶風向進行中',
 cd_manip_backfire: '反效果',
 cd_manip_success: '開始帶風向！',
 ex_manip_badge: '風向',
 whale_phase_label: '鯨魚動向',
 whale_phase_dormant: '風平浪靜',
 whale_phase_accumulating: '鯨魚吃貨中',
 whale_phase_pumping: '拉盤在即',
 whale_phase_dumping: '倒貨風險',
 whale_tracker_btn: '鯨魚錢包追蹤器',
 whale_tracker_sub: '看廣告查看鯨魚階段',
 rescue_btn: '攤平緊急資金',
 rescue_sub: '看廣告領取資金',
 rescue_cooldown: '冷卻',
 rescue_received: '已收到緊急資金！',
 ad_fact_check: '事實查核',
 ad_whale_tracker: '鯨魚追蹤',
 ad_rescue_funds: '緊急資金',

 // === Volatility engine + rug pull (Sprint 2b) ===
 ex_rug_badge: '跑路',
 cnews_rug_alert: '緊急：偵測到 {coin} 開發團隊錢包大量轉出',

 // Loss-aversion ad hooks (Sprint 2b)
 panic_btn: '緊急逃離',
 panic_sub: '看廣告以暴跌前價格賣出50%',
 panic_success: '緊急逃離成交！',
 insurance_btn: '跑路保險',
 insurance_sub: '看廣告啟用30分鐘保障',
 insurance_active: '保險生效中',
 insurance_payout: '保險理賠',
 rewind_btn: '交易倒帶',
 rewind_sub: '看廣告撤銷上一筆交易',
 rewind_success: '已撤銷上一筆交易！',
 ad_panic_sell: '緊急逃離',
 ad_rug_insurance: '跑路保險',
 ad_trade_rewind: '交易倒帶',

 // Dark pool x exchange link (Sprint 2b)
 cnews_dp_pump: '暗池熱門幣 {coin} 交易所行情升溫',

 // === 虛擬企業 (Sprint 3a) ===
 co_voltmotors: '伏特汽車', co_moonbase: '月亮基地', co_hashworks: '哈希工坊', co_moonlightent: '月光娛樂', co_goldenfry: '黃金炸雞', co_pumpcapital: '拉盤資本',
 cnews_co_volt_payment: '{company}宣布電動車支援{coin}支付',
 cnews_co_volt_recall: '{company}主力電動車大規模召回，{coin}情緒降溫',
 cnews_co_moonbase_listing: '{company}將{coin}升級至主板市場',
 cnews_co_moonbase_outage: '{company}伺服器癱瘓，{coin}交易暫停',
 cnews_co_hash_rig: '{company}發表新款礦機，{coin}算力飆升',
 cnews_co_hash_shock: '{company}財報爆雷，憂心{coin}挖礦縮減',
 cnews_co_mle_idol: '{company}偶像發起{coin}迷因挑戰',
 cnews_co_mle_scandal: '{company}旗下明星醜聞，{coin}迷因熱度急凍',
 cnews_co_gfry_event: '{company}推出{coin}支付炸雞半價活動',
 cnews_co_gfry_ceo: '{company}執行長被捕，{coin}社群震驚',
 cnews_co_pcap_buy: '{company}執行長發文大量買進{coin}',
 cnews_co_pcap_probe: '{company}遭搜索，{coin}主力資金疑雲',

 // === News comment section (Sprint 3a) ===
 ncm_title: '留言', ncm_you: '我', ncm_your_take: '你怎麼看?', ncm_open_hint: '查看留言',
 stance_moon: '衝上月球', stance_cut: '停損啦', stance_watch: '先觀望', stance_rekt: '只有我被套嗎',
 // 利多留言池 (cmt_up)
 cmt_up_1: '死抱的人才會贏', cmt_up_2: '這就是底部快買', cmt_up_3: '這要噴了', cmt_up_4: '全倉買進',
 cmt_up_5: '終於要解套了', cmt_up_6: '主力進場衝啊', cmt_up_7: '線圖一路向上', cmt_up_8: '這次真的要漲了',
 cmt_up_9: '牛市開始了', cmt_up_10: '現在不買會後悔', cmt_up_11: '成交量爆了', cmt_up_12: '停損的人在流淚',
 cmt_up_13: '回到我的成本價衝', cmt_up_14: '這才叫噴出', cmt_up_15: '持有的人在笑', cmt_up_16: '該加碼了',
 cmt_up_17: '鯨魚正在吸貨', cmt_up_18: '這消息翻倍很輕鬆', cmt_up_19: '終於反彈了', cmt_up_20: '抱了三年的人笑了',
 cmt_up_21: '錯過這波窮一輩子', cmt_up_22: '衝上月球繫好安全帶', cmt_up_23: '大家都有就我沒這幣', cmt_up_24: '獲利了結是門藝術',
 cmt_up_25: '主力大大我在這', cmt_up_26: '這支我把身家都梭了各位', cmt_up_27: '這就是底部第三天了', cmt_up_28: '我是來種田挖礦的',
 cmt_up_29: '迷因幣就是用感情買的', cmt_up_30: '這房總在起鬨但我也進了', cmt_up_31: '黃金交叉剛出現', cmt_up_32: '把散戶全燒光',
 cmt_up_33: '突破要來了快抓', cmt_up_34: '我押這支一定衝', cmt_up_35: '在回檔時買進了', cmt_up_36: '成功抄到底部',
 cmt_up_37: '今晚吃牛排不吃泡麵', cmt_up_38: '終於出現紅K了', cmt_up_39: '我早就預言中了', cmt_up_40: '幸好沒停損',
 cmt_up_41: '真的有量進來了', cmt_up_42: '這幣改版成功有望', cmt_up_43: '創新高衝啊', cmt_up_44: '分批買單全填滿了',
 cmt_up_45: '這次感覺真的不一樣', cmt_up_46: '線圖畫得好漂亮', cmt_up_47: '套的終於回本了', cmt_up_48: '支撐反彈確認',
 cmt_up_49: '看得出主力吸貨痕跡', cmt_up_50: '大家一起喊買', cmt_up_51: '這是下一個十倍幣', cmt_up_52: '現在上車還不算末班車',
 cmt_up_53: '散戶的勝利', cmt_up_54: '在成本價下方撿到了', cmt_up_55: '好期待明天早上', cmt_up_56: '認證持有者在此',
 cmt_up_57: '信這房全倉進場', cmt_up_58: '反彈架式擺好了', cmt_up_59: '死抱王者就在這裡', cmt_up_60: '今天也向上感謝',
 cmt_up_61: '這房的人怎麼都這麼有信心', cmt_up_62: '早知道就多梭一點可惜', cmt_up_63: '攤平真是神來一手', cmt_up_64: '每次跌都撿現在笑了',
 cmt_up_65: '死抱不會背叛你', cmt_up_66: '這幣越看越順眼繼續買', cmt_up_67: '看到紅K心就安了', cmt_up_68: '聽說鯨魚錢包動了真的嗎',
 cmt_up_69: '不用再配泡麵配眼淚了', cmt_up_70: '這波上漲是有基本面的', cmt_up_71: '停損的人現在肚子好痛吧', cmt_up_72: '線圖終於聽話了',
 cmt_up_73: '幣圈說到底就是心態戰', cmt_up_74: '只要抓好獲利時機就行', cmt_up_75: '這房氣氛好久沒這麼暖', cmt_up_76: '套的一回本立刻閃人',
 cmt_up_77: '現在不買又要後悔了', cmt_up_78: '感覺得到主力在拉抬', cmt_up_79: '今天看帳戶好開心', cmt_up_80: '死抱三年終於見到光',
 cmt_up_81: '不買這支就變窮光蛋', cmt_up_82: '這線圖讓我心臟狂跳', cmt_up_83: '手指比腦子先按下買進', cmt_up_84: '今天雞排錢已經賺到了',
 cmt_up_85: '這比種田好多了', cmt_up_86: '幣圈永遠向上至少今天真的', cmt_up_87: '信喊單房是神來一手', cmt_up_88: '衝上月球心臟要炸了',
 cmt_up_89: '死抱三年還沒陣亡', cmt_up_90: '這次總算不是我被套', cmt_up_91: '獲利是藝術停損是技術', cmt_up_92: '攤平不是淹死是獲救',
 cmt_up_93: '在主力洗盤前成功逃出', cmt_up_94: '這房好久沒綻放笑容了', cmt_up_95: '還以為只有我帳戶在跌', cmt_up_96: '終於從泡麵畢業了',
 cmt_up_97: '誇獎抓到反彈的自己', cmt_up_98: '高點套的貨終於快回本', cmt_up_99: '這支預約十倍幣', cmt_up_100: '今天帳戶是孝子',
 // 利空留言池 (cmt_down)
 cmt_down_1: '這是主力在玩', cmt_down_2: '停損訊號出現了', cmt_down_3: '又被套只有我', cmt_down_4: '快逃啊現在',
 cmt_down_5: '所以才說別碰幣', cmt_down_6: '有拉地毯的味道', cmt_down_7: '在高點接刀的舉手', cmt_down_8: '恐慌拋售開始',
 cmt_down_9: '我的本金去哪了', cmt_down_10: '線圖崩了', cmt_down_11: '這幣完蛋了', cmt_down_12: '主力開始倒貨',
 cmt_down_13: '現在還來得及丟', cmt_down_14: '含淚停損', cmt_down_15: '這是真的嗎', cmt_down_16: '早該賣了',
 cmt_down_17: '沒反彈快跑', cmt_down_18: '持有的人今天又下地獄', cmt_down_19: '只有散戶在死', cmt_down_20: '這消息要腰斬了',
 cmt_down_21: '這線圖是心電圖嗎', cmt_down_22: '這根本要下架了', cmt_down_23: '停損就漲慣例', cmt_down_24: '去煮泡麵好了',
 cmt_down_25: '看散戶在那邊亂竄', cmt_down_26: '被套了只能死抱嗎', cmt_down_27: '主力又在洗散戶', cmt_down_28: '會逃的都是聰明人',
 cmt_down_29: '這房又在誘人攤平', cmt_down_30: '我的本金秒沒了', cmt_down_31: '小心死貓跳', cmt_down_32: '支撐被跌破了',
 cmt_down_33: '心態徹底崩了', cmt_down_34: '今天又是綠K派對', cmt_down_35: '這是捲款準備中', cmt_down_36: '把散戶榨到見骨',
 cmt_down_37: '腰斬認證', cmt_down_38: '死抱到直接歸零', cmt_down_39: '均線全部跌破', cmt_down_40: '主力撤離訊號',
 cmt_down_41: '現在丟才划算', cmt_down_42: '別再開希望迴路了', cmt_down_43: '這幣沒救了', cmt_down_44: '距高點-80%',
 cmt_down_45: '攤平攤到全賠光', cmt_down_46: '線圖階梯式下跌', cmt_down_47: '今天又是眼淚配泡麵', cmt_down_48: '所以說幣圈就是賭博',
 cmt_down_49: '散戶地獄開張了', cmt_down_50: '就知道這起鬨沒好下場', cmt_down_51: '停損才是解答', cmt_down_52: '只有主力在笑',
 cmt_down_53: '我的帳戶在融化', cmt_down_54: '這撐不住了', cmt_down_55: '等反彈等到老', cmt_down_56: '散戶終究是砲灰',
 cmt_down_57: '這房喊什麼你就反著做', cmt_down_58: '停損鍵按不下去', cmt_down_59: '希望是種奢侈', cmt_down_60: '今天帳戶又焦土了',
 cmt_down_61: '這房又在帶風向小心', cmt_down_62: '我的本金在融化是真的嗎', cmt_down_63: '攤平才是解答結果套更深', cmt_down_64: '難道只有我套在高點',
 cmt_down_65: '大家別再傳希望迴路了', cmt_down_66: '這幣不是要下架了嗎', cmt_down_67: '泡麵都吃不起只能喝水了', cmt_down_68: '不停損死抱才落得這下場',
 cmt_down_69: '聽說鯨魚全倒完貨跑了', cmt_down_70: '這波跌得毫無理由好可怕', cmt_down_71: '總是只有獲利了結的人贏', cmt_down_72: '線圖直接往地下室鑽',
 cmt_down_73: '都說是心態戰結果我倒下了', cmt_down_74: '錯過停損時機是致命傷', cmt_down_75: '這房氣氛變成靈堂了', cmt_down_76: '這輩子應該回不了本了',
 cmt_down_77: '現在丟掉是不是還比較划算', cmt_down_78: '主力洗完散戶就跑了', cmt_down_79: '今天連看帳戶都害怕', cmt_down_80: '死抱三年還是負的',
 cmt_down_81: '線圖是心電圖吧快嗶嗶叫了', cmt_down_82: '想賺雞排錢結果賠掉雞排店', cmt_down_83: '這房又開始洗盤了', cmt_down_84: '信喊單房的我是笨蛋',
 cmt_down_85: '手指自己按下了買進', cmt_down_86: '攤平攤到直接淹死', cmt_down_87: '就我被套原來只有我被套', cmt_down_88: '早知道去種田還比較好',
 cmt_down_89: '幣圈向上只有我帳戶向下', cmt_down_90: '這就是底部喊到第三天了', cmt_down_91: '死抱還是停損答案是已經太遲', cmt_down_92: '主力洗盤連盤子一起端走',
 cmt_down_93: '我的本金到底去哪了真的', cmt_down_94: '都說會逃的是聰明人我不是', cmt_down_95: '等反彈等到頭髮白', cmt_down_96: '早該反著做這房的喊單',
 cmt_down_97: '停損鍵物理上按不下去', cmt_down_98: '今天泡麵湯特別鹹', cmt_down_99: '希望迴路開始冒煙了', cmt_down_100: '窮光蛋路線正常進行中',
 // NPC 一般回覆池 (npc_reply)
 npc_reply_1: '你說得對', npc_reply_2: '這有點不對吧', npc_reply_3: '我也這樣看', npc_reply_4: '不是只有你這樣',
 npc_reply_5: '去看線圖啦', npc_reply_6: '已經太遲了', npc_reply_7: '再等等看', npc_reply_8: '最後還是主力贏',
 npc_reply_9: '看看你的預言會不會成真老哥', npc_reply_10: '老實說這次感覺好像有點不一樣', npc_reply_11: '這次我大致上同意你', npc_reply_12: '我們都在主力的手掌心裡玩',
 npc_reply_13: '在這裡攤平要非常小心', npc_reply_14: '得先盯住鯨魚的動作', npc_reply_15: '守住停損線才是真本事', npc_reply_16: '大家太有信心時反而要小心',
 // NPC 回覆 - 回應偏多立場 (bull)
 npc_reply_bull_1: '衝啊只信老哥', npc_reply_bull_2: '我也全倉了', npc_reply_bull_3: '這次真的會漲嗎', npc_reply_bull_4: '別高興得太早',
 npc_reply_bull_5: '信你老哥全倉進場', npc_reply_bull_6: '這次看起來真有基本面', npc_reply_bull_7: '我也在下跌時撿了貨', npc_reply_bull_8: '主力進場空頭就出局了',
 npc_reply_bull_9: '我也準備長抱了', npc_reply_bull_10: '攤平把成本壓低了', npc_reply_bull_11: '看到紅K就多買了', npc_reply_bull_12: '這房好久沒讓我有信心了',
 npc_reply_bull_13: '只要抓好出場時機就好', npc_reply_bull_14: '鯨魚真的在買那就穩了', npc_reply_bull_15: '準備吃牛排吧兄弟們', npc_reply_bull_16: '衝啊這次感覺真的很好',
 // NPC 回覆 - 回應偏空立場 (bear)
 npc_reply_bear_1: '原來停損才對', npc_reply_bear_2: '原來不是只有我被套', npc_reply_bear_3: '膽小的先停損', npc_reply_bear_4: '我還在硬撐',
 npc_reply_bear_5: '看來停損才是對的', npc_reply_bear_6: '攤平結果套得更深了', npc_reply_bear_7: '幸好套在高點的不只我', npc_reply_bear_8: '聽得見我本金融化的聲音',
 npc_reply_bear_9: '看來該戒掉希望迴路了', npc_reply_bear_10: '獲利了結的人才是贏家', npc_reply_bear_11: '回本現在完全沒指望了', npc_reply_bear_12: '今晚看來又要吃泡麵了',
 npc_reply_bear_13: '主力把貨倒給我們就跑了', npc_reply_bear_14: '線圖往地下室鑽好可怕', npc_reply_bear_15: '認輸這場心態戰我輸了', npc_reply_bear_16: '我僵住了停損鍵按不下去',
 // NPC 回覆 - 回應中立立場 (neut)
 npc_reply_neut_1: '觀望也是實力', npc_reply_neut_2: '看著才是上策', npc_reply_neut_3: '猶豫就是輸', npc_reply_neut_4: '我也先等等',
 npc_reply_neut_5: '看到明確趨勢前我先觀望', npc_reply_neut_6: '毫無根據的信心很危險', npc_reply_neut_7: '確認趨勢再攤平吧', npc_reply_neut_8: '先看鯨魚錢包動向再說',
 npc_reply_neut_9: '沒量的反彈可能是陷阱', npc_reply_neut_10: '設好停損線再盯著看', npc_reply_neut_11: '紅K時分批進場', npc_reply_neut_12: '這房的信心反而讓我不安',
 npc_reply_neut_13: '獲利也要有計畫才行', npc_reply_neut_14: '往地下室鑽就不碰', npc_reply_neut_15: '先做好心態管理再說', npc_reply_neut_16: '先觀望才是上策',
 // === 資產排行榜 ===
 lb_title: '資產排行榜',
 lb_entry_title: '資產排行榜',
 lb_entry_sub: '總資產排名 - 與鯨魚競爭',
 lb_your_rank: '{total}人中第{rank}名',
 lb_your_assets: '我的總資產',
 lb_best_rank: '最高第{rank}名',
 lb_you: '我',
 lb_footnote: '總資產 = 現金 + 持有幣估值。排行榜上的人也在持續增值 — 一鬆懈就會被超越。',
 // === Fake Signal Rooms (Sprint 3a) ===
 lr_title: '喊單房', lr_intro: '跟著房主的喊單，判斷哪個房間是真的。可信度不會顯示。',
 lr_entry_title: '進入喊單房', lr_entry_sub: '房主喊單 - 命中率追蹤 - 情報販子',
 lr_no_call: '沒有待處理的喊單', lr_no_history: '沒有紀錄', lr_track_record: '命中紀錄',
 lr_hit: '命中', lr_miss: '失手',
 lr_vip_tag: 'VIP', lr_vip_enter: '進入VIP房', lr_vip_sub: '看廣告換高可信房入場券',
 lr_vip_unlocked: 'VIP房已解鎖', lr_locked_hint: '高可信精英房 - 需要入場券',
 // 房名 + 房主介紹
 room_newbie: '新手脫離房', room_newbie_tag: '「不問直接全押！今天也衝了！」',
 room_diamond: '鑽石持有者房', room_diamond_tag: '「只憑技術線喊單」',
 room_insider: '內部消息房', room_insider_tag: '「相信大哥，消息絕對可靠」',
 room_whale: '巨鯨士官學校', room_whale_tag: '「搶先看穿主力的動作」',
 room_oracle: '神諭之房', room_oracle_tag: '「用命中率證明」',
 // 房主喊單 (call_up = 誘買, call_down = 誘賣)
 call_up_1: '{coin} 現在進場直接翻兩倍', call_up_2: '{coin} 拿到上架消息，全押角度',
 call_up_3: '{coin} 抓到主力吸籌，現在就是機會', call_up_4: '{coin} 打好底了，加碼喊單',
 call_down_1: '{coin} 現在丟掉，暴跌要來了', call_down_2: '{coin} 主力撤離訊號，該停損',
 call_down_3: '{coin} 到頂了，獲利了結快出', call_down_4: '{coin} 利空要出，提前清倉',
 ad_vip_room: 'VIP喊單房入場券',

 // === Info Broker (Sprint 3a) ===
 shop_title: '情報販子', shop_intro: '交易所後巷。用遊戲幣賣情報 - 又貴又模糊。',
 shop_bought: '取得情報', shop_no_info: '現在沒有情報可賣',
 shop_whale_hint: '主力動向耳語', shop_whale_hint_desc: '指出一個有動作的幣（不知階段）',
 shop_news_tip: '下則新聞幣', shop_news_tip_desc: '只告訴你下則新聞會打哪個幣（方向保密）',
 shop_room_leak: '喊單房內幕調查', shop_room_leak_desc: '大略透露某房的可信度等級',
 shop_hint_whale: '「{coin}… 聽說最近有大戶在進場」',
 shop_hint_news: '「下個大消息聽說會在{coin}爆」',
 shop_hint_room: '「{room}？那房的可信度大概是{band}」',
 shop_band_low: '低', shop_band_mid: '中', shop_band_high: '高',

 // === 帶單房即時聊天 (Sprint 3b) ===
 lrc_quiet: '房間很安靜...',
 rc_me: '我', rc_moon: '衝上月球', rc_cut: '已停損', rc_watch: '先觀望',
 // 擁護 / 帶風向
 chat_advocate_1: '衝啊各位', chat_advocate_2: '鑽石手必勝',
 chat_advocate_3: '這支真的會噴', chat_advocate_4: '錯過後悔一輩子',
 chat_advocate_5: '全倉梭了', chat_advocate_6: '這次感覺不一樣',
 chat_advocate_7: '長期持有者笑到最後', chat_advocate_8: '這是最後的底部',
 chat_advocate_9: '衝上月球繫好安全帶', chat_advocate_10: '錯過就變窮光蛋',
 chat_advocate_11: '主力大大我在這', chat_advocate_12: '把身家全梭進去了',
 chat_advocate_13: '大家都有就我沒', chat_advocate_14: '獲利了結是門藝術',
 chat_advocate_15: '迷因幣是用感情買的', chat_advocate_16: '爆量了快抓',
 chat_advocate_17: '突破要來了', chat_advocate_18: '黃金交叉出現了',
 chat_advocate_19: '散戶的勝利', chat_advocate_20: '今晚吃牛排',
 chat_advocate_21: '回本就在眼前', chat_advocate_22: '信這房進場了',
 chat_advocate_23: '在回檔買進了', chat_advocate_24: '這是下一個十倍幣',
 chat_advocate_25: '反彈架式擺好了', chat_advocate_26: '這才是真的底部',
 chat_advocate_27: '綠燈亮了', chat_advocate_28: '抱三年的人笑了',
 chat_advocate_29: '信各位我死抱了', chat_advocate_30: '會抄底才是真本事', chat_advocate_31: '主力進場這次不一樣', chat_advocate_32: '攤平把成本壓低了',
 chat_advocate_33: '這是最後撿貨的機會', chat_advocate_34: '鑽石手在此報到', chat_advocate_35: '反彈要來了快撿貨兄弟們', chat_advocate_36: '基本面很好我繼續囤',
 chat_advocate_37: '看到紅K好舒服該買了', chat_advocate_38: '聽說鯨魚在瘋狂吸貨', chat_advocate_39: '死抱三年準備上月球', chat_advocate_40: '今晚吃牛排吧兄弟們',
 chat_advocate_41: '死抱必勝信了三年', chat_advocate_42: '不買這支就變窮光蛋', chat_advocate_43: '今天雞排錢就在這裡賺', chat_advocate_44: '手指比腦子先按下買進',
 chat_advocate_45: '這是底部這次真的', chat_advocate_46: '衝上月球心臟撐住', chat_advocate_47: '這次信這房的喊單', chat_advocate_48: '照喊單房全倉梭了',
 chat_advocate_49: '收了種田來這裡', chat_advocate_50: '今天帳戶是孝子',
 // 嘲諷 / 質疑
 chat_cynic_1: '別亂散播謠言', chat_cynic_2: '套牢了?',
 chat_cynic_3: '經典散戶洗盤', chat_cynic_4: '會逃才是本事',
 chat_cynic_5: '又是這個房間', chat_cynic_6: '別為主力起舞',
 chat_cynic_7: '又一堵拉盤刷屏', chat_cynic_8: '只有韭菜才追這種喊單',
 chat_cynic_9: '這房又在起鬨了', chat_cynic_10: '別再開希望迴路了',
 chat_cynic_11: '主力會很開心的', chat_cynic_12: '這喊單反著做就對',
 chat_cynic_13: '這是心電圖線圖嗎', chat_cynic_14: '又在誘人攤平了',
 chat_cynic_15: '有拉地毯的味道', chat_cynic_16: '在這召募砲灰',
 chat_cynic_17: '別被死貓跳騙了', chat_cynic_18: '起鬨總是這種下場',
 chat_cynic_19: '信這喊單就當接盤俠', chat_cynic_20: '拉盤房的慣例出現了',
 chat_cynic_21: '只會燒散戶的局', chat_cynic_22: '在幫主力做出場',
 chat_cynic_23: '笑著走向下架', chat_cynic_24: '這房在賣希望',
 chat_cynic_25: '又有人被套了', chat_cynic_26: '泡沫退了就知道答案',
 chat_cynic_27: '那賣壓就是主力', chat_cynic_28: '散戶終究是最後一棒',
 chat_cynic_29: '這房這麼有信心反而讓我不安', chat_cynic_30: '帶風向帶太兇散戶保護好自己', chat_cynic_31: '有在製造出場流動性的味道', chat_cynic_32: '這明顯是主力陷阱',
 chat_cynic_33: '這房反著做保證獲利', chat_cynic_34: '只有賣希望的人在贏', chat_cynic_35: '又有人要被套牢了', chat_cynic_36: '為死貓跳精神勝利罷了',
 chat_cynic_37: '一講主力吸貨就該倒貨', chat_cynic_38: '死抱三年還好意思炫耀', chat_cynic_39: '牛排只有主力在吃', chat_cynic_40: '信這房就準備吃泡麵',
 chat_cynic_41: '這房又開始洗盤了', chat_cynic_42: '會逃的是聰明人不是這房', chat_cynic_43: '想賺雞排錢賠掉雞排店', chat_cynic_44: '信喊單房那刻就當接盤俠',
 chat_cynic_45: '這是底部喊到第三天了', chat_cynic_46: '誘導你手指按下買進', chat_cynic_47: '這房喊單反著做每次都準', chat_cynic_48: '別給主力遞乾淨盤子',
 chat_cynic_49: '在這才悟到種田比較聰明', chat_cynic_50: '這房是通往窮光蛋的導覽',
 // 恐慌 / 自嘲
 chat_panic_1: '只有我套牢嗎', chat_panic_2: '該停損了嗎?',
 chat_panic_3: '這是要下架的節奏', chat_panic_4: '抱太久被燒了',
 chat_panic_5: '我的本金去哪了', chat_panic_6: '已經跌一半了',
 chat_panic_7: '所以說幣圈很痛', chat_panic_8: '心態已崩',
 chat_panic_9: '去煮泡麵好了', chat_panic_10: '我的帳戶在融化',
 chat_panic_11: '被套了只能死抱嗎', chat_panic_12: '我的帳戶焦土了',
 chat_panic_13: '今天又是眼淚配泡麵', chat_panic_14: '等反彈等到老',
 chat_panic_15: '停損鍵按不下去', chat_panic_16: '希望是種奢侈',
 chat_panic_17: '正在即時變窮光蛋', chat_panic_18: '這幣沒救了',
 chat_panic_19: '散戶地獄開張了', chat_panic_20: '距高點腰斬',
 chat_panic_21: '攤平攤到全賠光', chat_panic_22: '支撐破了怎麼辦',
 chat_panic_23: '心態撐不住了', chat_panic_24: '今天又是綠K派對',
 chat_panic_25: '錯過出場時機了', chat_panic_26: '沒想到死抱這麼難',
 chat_panic_27: '我的本金秒沒了', chat_panic_28: '現在只剩禱告了',
 chat_panic_29: '聽你們的攤平結果套更深', chat_panic_30: '我的資產真的在蒸發', chat_panic_31: '只有我剛好套在最高點嗎', chat_panic_32: '幾個月前就該停損的',
 chat_panic_33: '說好回本就走結果套住了', chat_panic_34: '主力全倒完了現在怎麼辦', chat_panic_35: '獲利了結的人一直都是聰明人', chat_panic_36: '線圖直往地下室挖我好怕',
 chat_panic_37: '心態戰徹底輸了我不玩了', chat_panic_38: '這房氣氛跟靈堂一樣', chat_panic_39: '今天打開帳戶都覺得反胃', chat_panic_40: '抱三年帳戶還是負的',
 chat_panic_41: '就我被套原來只有我被套', chat_panic_42: '想賺雞排錢賠掉雞排店', chat_panic_43: '攤平攤到直接淹死', chat_panic_44: '我的本金到底去哪了真的',
 chat_panic_45: '信喊單房的我是笨蛋', chat_panic_46: '停損鍵物理上按不下去', chat_panic_47: '這是底部哭喊到第三天了', chat_panic_48: '都說會逃的是聰明人我不是',
 chat_panic_49: '真後悔沒去好好種田', chat_panic_50: '窮光蛋路線正常進行中',
 // 分析 / 教學
 chat_analysis_1: '看圖就知道答案', chat_analysis_2: '看那個成交量',
 chat_analysis_3: '抄底吧', chat_analysis_4: '現在是攤平時機',
 chat_analysis_5: '支撐守住了', chat_analysis_6: '黃金交叉要來了',
 chat_analysis_7: '分批進場才是正解', chat_analysis_8: '沒量就只是回調',
 chat_analysis_9: '看得出主力吸貨痕跡', chat_analysis_10: '線圖畫成一路向上',
 chat_analysis_11: '突破壓力就噴', chat_analysis_12: '爆量才是真的',
 chat_analysis_13: '做短的守好停損', chat_analysis_14: '小心死貓跳先觀望',
 chat_analysis_15: '在回檔買進才對', chat_analysis_16: '均線多頭排列了',
 chat_analysis_17: '箱型上緣是壓力', chat_analysis_18: '沒量就別進場',
 chat_analysis_19: '確認主力賣壓區', chat_analysis_20: '分批賣出控制風險',
 chat_analysis_21: '線圖心理最重要', chat_analysis_22: '高點會出貨',
 chat_analysis_23: '跌破支撐就停損', chat_analysis_24: '趨勢還在就續抱',
 chat_analysis_25: '波動大時先觀望', chat_analysis_26: '看懂主力週期',
 chat_analysis_27: '量縮就準備下跌', chat_analysis_28: '風控才是真本事',
 chat_analysis_29: '這波沒基本面我先觀望', chat_analysis_30: '確認趨勢再開始攤平', chat_analysis_31: '先盯住鯨魚錢包動向', chat_analysis_32: '零量反彈就是多頭陷阱',
 chat_analysis_33: '進場前一定先設停損', chat_analysis_34: '追紅K要慢慢分批進', chat_analysis_35: '為回本硬凹只會被燒光', chat_analysis_36: '主力吸貨傳聞務必先查證',
 chat_analysis_37: '獲利了結要有實際出場計畫', chat_analysis_38: '別想接住落下的刀', chat_analysis_39: '管好情緒就是風控', chat_analysis_40: '聊天越看多你越該懷疑',
 chat_analysis_41: '任何喊單先確認理由', chat_analysis_42: '連喊三天底部就不是底', chat_analysis_43: '攤平前先確認趨勢否則淹死', chat_analysis_44: '進場前設停損才不會變窮光蛋',
 chat_analysis_45: '主力倒貨會先反映在量上', chat_analysis_46: '會逃才聰明先規劃出場', chat_analysis_47: '追雞排錢燒光本金要分批', chat_analysis_48: '先檢查鯨魚錢包動向',
 chat_analysis_49: '有量的反彈才是真反彈', chat_analysis_50: '獲利是藝術停損是技術都要計畫',
 // NPC 回應 (對玩家反應的回聲)
 chat_echo_up_1: '衝啊我也上', chat_echo_up_2: '就信老哥',
 chat_echo_up_3: '跟你一起進', chat_echo_up_4: '別太衝動',
 chat_echo_up_5: '信你老哥我全倉', chat_echo_up_6: '我也在下跌時撿了貨', chat_echo_up_7: '主力進場空頭出局', chat_echo_up_8: '紅K真好看我多買了',
 chat_echo_up_9: '我也準備長抱了', chat_echo_up_10: '這支感覺很好衝吧', chat_echo_up_11: '攤平把成本壓好了', chat_echo_up_12: '準備吃牛排吧兄弟們',
 chat_echo_up_13: '鯨魚在吸貨就穩了', chat_echo_up_14: '只要抓好出場時機就好', chat_echo_up_15: '這房終於讓我有信心了', chat_echo_up_16: '反彈確認了衝上月球',
 chat_echo_down_1: '我也停損了', chat_echo_down_2: '膽小鬼先跑',
 chat_echo_down_3: '明智之舉', chat_echo_down_4: '我還是抱著',
 chat_echo_down_5: '停損確實才是對的', chat_echo_down_6: '套在高點的不只我', chat_echo_down_7: '聽得見本金融化的聲音', chat_echo_down_8: '我戒掉希望迴路了',
 chat_echo_down_9: '只有獲利了結的人贏了', chat_echo_down_10: '回本已經是空談了', chat_echo_down_11: '今晚又吃泡麵了兄弟', chat_echo_down_12: '主力倒完貨就跑了',
 chat_echo_down_13: '線圖直往下鑽好可怕', chat_echo_down_14: '心態戰徹底把我打垮', chat_echo_down_15: '我僵住了按不下賣出', chat_echo_down_16: '我聰明地在血洗前抽身',
 chat_echo_neut_1: '觀望也是實力', chat_echo_neut_2: '再看看吧',
 chat_echo_neut_3: '猶豫就會輸錢', chat_echo_neut_4: '我也先等等',
 chat_echo_neut_5: '確定前先觀望', chat_echo_neut_6: '毫無根據的信心很危險', chat_echo_neut_7: '確認趨勢再攤平', chat_echo_neut_8: '動手前先看鯨魚錢包',
 chat_echo_neut_9: '零量的動作對我來說是陷阱', chat_echo_neut_10: '設好停損線先盯著', chat_echo_neut_11: '紅K慢慢分批進', chat_echo_neut_12: '過度看多讓我不安',
 chat_echo_neut_13: '記得真的要有出場計畫', chat_echo_neut_14: '一直跌就不碰', chat_echo_neut_15: '先做好風控再說', chat_echo_neut_16: '按兵不動最安全',
 // 謠言 (真偽隱藏)
 rumor_tag: '謠言', rumor_true: '真', rumor_fake: '假',
 rumor_check_btn: '查證', rumor_check_sub: '看廣告做事實查核',
 rumor_listing: '聽說 {coin} 要上大交易所',
 rumor_accumulate: '主力已經吸完 {coin} 的貨',
 rumor_partnership: '{coin} 的大型合作即將公布',
 rumor_delist: '據說 {coin} 明天就下架',
 rumor_rugpull: '{coin} 的開發者在準備跑路',
 rumor_dump: '主力準備砸盤 {coin}',
} as Record<string, string>;
